import { onBeforeUnmount } from "vue";

export function useTruncationTooltip() {
  // Use Map instead of object for O(1) cleanup
  const textRefs = new Map();
  const containerRefs = new Map();
  const itemRefs = new Map();

  const setTextRef = (el, key) => {
    if (el) {
      textRefs.set(key, el);
    } else {
      textRefs.delete(key);
    }
  };

  const setContainerRef = (el, key) => {
    if (el) {
      containerRefs.set(key, el);
    } else {
      containerRefs.delete(key);
    }
  };

  const setItemRef = (el, key) => {
    if (el) {
      itemRefs.set(key, el);
    } else {
      itemRefs.delete(key);
    }
  };

  const shouldShowTooltip = (key) => {
    const containerEl = containerRefs.get(key);
    const textEl = textRefs.get(key);
    const itemEl = itemRefs.get(key);

    if (containerEl && textEl) {
      const containerWidth = containerEl.offsetWidth;
      const textOffsetWidth = textEl.offsetWidth;

      if (itemEl) {
        const itemWidth = itemEl.offsetWidth;
        const availableWidth = itemWidth - 30;
        return textOffsetWidth > availableWidth;
      } else {
        return textOffsetWidth > containerWidth;
      }
    }

    return false;
  };

  // Cleanup stale refs (called from component on data change)
  const clearStaleRefs = (currentKeys) => {
    const currentSet = new Set(currentKeys);

    for (const key of textRefs.keys()) {
      if (!currentSet.has(key)) {
        textRefs.delete(key);
        containerRefs.delete(key);
        itemRefs.delete(key);
      }
    }
  };

  // Reset all refs (for use on pagination changes)
  const reset = () => {
    textRefs.clear();
    containerRefs.clear();
    itemRefs.clear();
  };

  // Cleanup all on unmount
  const cleanup = () => {
    reset();
  };

  onBeforeUnmount(() => {
    cleanup();
  });

  return {
    setTextRef,
    setContainerRef,
    setItemRef,
    shouldShowTooltip,
    clearStaleRefs,
    cleanup,
    reset,
  };
}
